/**
 * 三包登记的 表单验证规则
 * @author zjs
 * @time 2017-09-21
 */
export default {
    data () {
        // 非空的判断
        var isNoEmpty = (rule, value, callback) => {
            if (value === '') {
                callback(new Error('请输入'))
            } else {
                callback()
            }
        }
        return {
            formRules: {
                work_time: [{ required: true, trigger: 'blur' }],
                shoutai_time: [{ required: true, trigger: 'blur' }],
                // 2018-05-03修改，第三十三批需求，供应商编码 和 供应商名称 不必填
                // 'provider.provider_code' : [{ required: true, trigger: 'blur' }],
                // 'provider.provider_name': [{ required: true, trigger: 'blur' }],
                shoutaipj_no: [{ required: true, trigger: 'blur' }],
                warehouse_id: [{ validator: isNoEmpty, required: true, trigger: 'blur' }]
            }
        }
    },
    methods: {
        /**
         * 验证货品信息
         * @param  {[Array]} arr [货品列表]
         */
        validateProduct (arr) {
            let msg = '' // 提示的信息
            let index = -1 // 记录有问题的行
            for (let i in arr) {
                let row = arr[i]
                // let bool = false
                // 判断是否选择货品
                if (!row.product || !row.product.product_id) {
                    msg += '"货品"'
                }
                // 是否填写了胎号
                if (!row.tzce_amount || row.tzce_amount === 0) {
                    msg += '"调账差额"'
                }
                if (msg.length > 0) {
                    index = i
                    break;
                }
            }
            if (index >= 0) {
                msg = '第' + parseInt(parseInt(index) + 1) + '行还未选择\n' + msg
            }
            return msg
        }
    }
}